import { Tabs as AntdTabs, Badge, Col } from 'antd'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { ReactComponent as ChecklistIcon } from 'assets/icons/checklist.svg'
import colors from 'global/styles/colors'
import { ReactComponent as CommentIcon } from 'assets/icons/comment.svg'
import featureCodes from 'constants/featureCodes'
import { ReactComponent as GantryIcon } from 'assets/icons/gantry.svg'
import Icon from '@ant-design/icons'
import paths from 'constants/paths'
import PropTypes from 'prop-types'
import React from 'react'
import { ReactComponent as StopwatchIcon } from 'assets/icons/stopwatch.svg'
import useFeatureAccessControlEnabled from 'hooks/useFeatureAccessControlEnabled'
import { useTranslation } from 'react-i18next'

import './tabs.less'
import TabLoadingSkeleton from './TabsLoadingSkeleton'

const Tabs = ({ isLoading, noOfComments, noOfContainerNotes, noOfRemarks }) => {
  const { t } = useTranslation()
  const { tab } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const showContainerNotes = useFeatureAccessControlEnabled(
    featureCodes.SHOW_CONTAINER_NOTES
  )

  const renderTabBar = (props, DefaultTabBar) => (
    <div className="tabs__container">
      <DefaultTabBar {...props} style={{ border: 0, margin: 0 }} />
    </div>
  )

  const tabItems = [
    {
      key: paths.portCall.summary,
      label: (
        <span className="tabs__label">
          <Icon component={ChecklistIcon} />
          {t('portCall.summary')}
        </span>
      ),
    },
    {
      key: paths.portCall.shipOverview,
      label: (
        <span className="tabs__label">
          <Icon component={GantryIcon} />
          {t('portCall.shipOverview.shipOverview')}
        </span>
      ),
    },
    {
      key: paths.portCall.productivity,
      label: (
        <span className="tabs__label">
          <Icon component={StopwatchIcon} />
          {t('portCall.productivity')}
        </span>
      ),
    },
    {
      key: paths.portCall.comments,
      label: (
        <span className="tabs__label tabs__label--comments-and-logbook">
          <Icon component={CommentIcon} />
          {showContainerNotes ? (
            <span className="tabs__label tabs__label--comments-logbook-and-cntainer-notes">
              {t('portCall.commentsTab.commentsLogbookAndContainerNotes')}
            </span>
          ) : (
            <span className="tabs__label tabs__label--comments-and-logbook">
              {t('portCall.commentsTab.commentsAndLogbook')}
            </span>
          )}
          {showContainerNotes ? (
            <Badge
              className={'tabs__logbook-and-containernote-remarks-badge'}
              count={noOfRemarks + noOfContainerNotes}
              style={{ backgroundColor: colors.brandOrange }}
            />
          ) : (
            <>
              <Badge
                className={'tabs__remarks-badge'}
                count={noOfRemarks}
                style={{ backgroundColor: colors.brandOrange }}
              />
              <Badge
                className="tabs__comments-badge"
                count={noOfComments}
                style={{ backgroundColor: colors.brandOrange }}
              />
            </>
          )}
        </span>
      ),
    },
  ]

  return (
    <Col span={24}>
      {isLoading ? (
        <TabLoadingSkeleton />
      ) : (
        <AntdTabs
          activeKey={tab}
          animated={false}
          items={tabItems}
          renderTabBar={renderTabBar}
          onChange={activeKey => {
            const newPathName = tab
              ? location.pathname.replace(`/${tab}`, '')
              : location.pathname

            navigate({
              pathname: `${newPathName}/${activeKey}`,
            })
          }}
        />
      )}
    </Col>
  )
}

Tabs.defaultProps = {
  isLoading: false,
}

Tabs.propTypes = {
  isLoading: PropTypes.bool,
  noOfComments: PropTypes.number.isRequired,
  noOfContainerNotes: PropTypes.number.isRequired,
  noOfRemarks: PropTypes.number.isRequired,
}

export default Tabs
